import React, { useState } from "react"
import { TextField, Button, Snackbar, Alert } from "@mui/material"
import { collection, addDoc } from "firebase/firestore"
import { db } from "../firebase/config"
import styles from "../styles/QuestionForm.module.scss"
import { getDeviceId } from "../utils/deviceUtils"

const QuestionForm = ({ admin }) => {
  const [text, setText] = useState("")
  const [open, setOpen] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    const deviceId = await getDeviceId()

    if (!text.trim()) return
    try {
      await addDoc(collection(db, "questions"), {
        text,
        upvotes: 0,
        author: admin ? "admin" : "Anonymous",
        deviceId,
        createdAt: new Date()
      })
      setText("")
      setOpen(true)
    } catch (err) {
      console.error("Error adding question:", err)
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit} className={styles.form}>
        <TextField
          label="Type your question..."
          variant="outlined"
          value={text}
          onChange={(e) => setText(e.target.value)}
          fullWidth
          className={styles.input}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={styles.button}
        >
          Send
        </Button>
      </form>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="success">Question sent!</Alert>
      </Snackbar>
    </>
  )
}

export default QuestionForm
